/**
 * `<TimezoneSelect>` — sélecteur de fuseau horaire réutilisable (planning de
 * shift, programmation de posts, popover de l'horloge).
 *
 * Depuis le 02-11-2026 le dessin est `Temps.SelecteurFuseau` (le `Select` de la
 * librairie, groupé par région, l'avance sur UTC dans chaque libellé :
 * « Paris · UTC+2 »). Ce fichier ne garde que la liste curatée du cockpit
 * (`COMMON_TIMEZONES`, `@/shared/timezone`) : le fuseau de l'APPAREIL est
 * toujours proposé en tête (groupe « Détecté »), et la `value` courante est
 * garantie présente même si c'est une zone exotique.
 */
import { Temps } from "@dozka/ui";

import { COMMON_TIMEZONES } from "@/shared/timezone";

interface TimezoneSelectProps {
  value: string;
  onChange: (tz: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  ariaLabel?: string;
}

const FUSEAUX: Temps.OptionFuseau[] = COMMON_TIMEZONES.map((z) => ({
  id: z.id,
  ville: z.label,
  region: z.region,
}));

export function TimezoneSelect({
  value,
  onChange,
  disabled,
  className,
  id,
  ariaLabel,
}: TimezoneSelectProps) {
  return (
    <Temps.SelecteurFuseau
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
      id={id}
      aria-label={ariaLabel}
      fuseaux={FUSEAUX}
    />
  );
}
